<template>
  <v-container grid-list-sm text-xs-center>
    <v-layout row wrap>
      <v-flex xs11>
        <v-form autocomplete="off">
          <v-layout row wrap align-center>
            <v-flex sm3 subheading>Name: </v-flex>
            <v-flex sm9>
              <v-text-field v-model="name" label="Name" required @blur="$v.name.$touch()" :error-messages="nameErrorMsgs"></v-text-field>
            </v-flex>
            
            <v-flex sm3 subheading>Description: </v-flex>
            <v-flex sm9>
              <v-text-field v-model="description" label="Description" required @blur="$v.description.$touch()" :error-messages="descriptionErrorMsgs"></v-text-field>
            </v-flex>
            
            <v-flex sm3 subheading>Status: </v-flex>
            <v-flex sm9>
              <v-autocomplete :items="statusArray" v-model="status" label="Select" item-text="status" item-value="status" hint="Select Status">
                <template slot='items' slot-scope='status'>{{ status }}</template>
              </v-autocomplete>
            </v-flex>

            <v-flex sm3 subheading><v-btn icon class="mx-0" @click.native="newElementDialog = true"><v-icon>add</v-icon></v-btn> Config: </v-flex>
            <v-layout row v-for="(item, key) in config" class="full-width" :key=key>
              <v-flex v-if="key !== 'rules' && key !== 'databaseName' && key !== 'newsapi' && key !== 'bingnewsapi' && key !== 'bingwebapi' && key !== 'databaseHost' && key !== 'databasePort' && key !== 'databaseUser' && key !== 'databasePassword' && key !== 'databaseProvider' && key !== 'freeTwitterApiUse' && key !== 'freeTwitterApiUseStrict' && key !== 'freeTwitterApiHandles' && key !== 'freeTwitterApiHashtags' && key !== 'freeTwitterApiKeywords' && key !== 'freeTwitterApiConsumerKey' && key !== 'freeTwitterApiConsumerSecret' && key !== 'freeTwitterApiAccessToken' && key !== 'freeTwitterApiAccessTokenSecret' && key !== 'freeTwitterApiUseRestricted' && key !== 'freeTwitterApiHandlesRestricted' && key !== 'freeTwitterApiKeywordsRestricted' && key !== 'excludeTerms' && key !== 'excludeTwitterUsers' && key !== 'excludeDomains'" sm4 subheading offset-sm3 class="text-sm-left"> 
                {{key}}: 
              </v-flex>
              <v-flex v-if="key !== 'rules' && key !== 'databaseName' && key !== 'newsapi' && key !== 'bingnewsapi' && key !== 'bingwebapi' && key !== 'databaseHost' && key !== 'databasePort' && key !== 'databaseUser' && key !== 'databasePassword' && key !== 'databaseProvider' && key !== 'freeTwitterApiUse' && key !== 'freeTwitterApiUseStrict' && key !== 'freeTwitterApiHandles' && key !== 'freeTwitterApiHashtags' && key !== 'freeTwitterApiKeywords' && key !== 'freeTwitterApiConsumerKey' && key !== 'freeTwitterApiConsumerSecret' && key !== 'freeTwitterApiAccessToken' && key !== 'freeTwitterApiAccessTokenSecret' && key !== 'freeTwitterApiUseRestricted' && key !== 'freeTwitterApiHandlesRestricted' && key !== 'freeTwitterApiKeywordsRestricted' && key !== 'excludeTerms' && key !== 'excludeTwitterUsers' && key !== 'excludeDomains'" sm8>
                <v-text-field v-model="config[key]" :label="key"></v-text-field>
              </v-flex>
              
              <v-flex v-if="key === 'newsapi'" sm4 subheading offset-sm3 class="text-sm-left"> 
                news api: 
              </v-flex>
              <v-flex v-if="key === 'newsapi'" sm8>
                <v-text-field v-model="config[key]" :label="'news api'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'bingnewsapi'" sm4 subheading offset-sm3 class="text-sm-left"> 
               bing news api: 
              </v-flex>
              <v-flex v-if="key === 'bingnewsapi'" sm8>
                <v-text-field v-model="config[key]" :label="'bing news api'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'bingwebapi'" sm4 subheading offset-sm3 class="text-sm-left"> 
               bing web api: 
              </v-flex>
              <v-flex v-if="key === 'bingwebapi'" sm8>
                <v-text-field v-model="config[key]" :label="'bing web api'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'excludeTerms'" sm4 subheading offset-sm3 class="text-sm-left"> 
               exclude terms: 
              </v-flex>
              <v-flex v-if="key === 'excludeTerms'" sm8>
                <v-text-field v-model="config[key]" :label="'exclude terms'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'excludeTwitterUsers'" sm4 subheading offset-sm3 class="text-sm-left"> 
               exclude twitter users: 
              </v-flex>
              <v-flex v-if="key === 'excludeTwitterUsers'" sm8>
                <v-text-field v-model="config[key]" :label="'exclude twitter users'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'excludeDomains'" sm4 subheading offset-sm3 class="text-sm-left"> 
               exclude domains: 
              </v-flex>
              <v-flex v-if="key === 'excludeDomains'" sm8>
                <v-text-field v-model="config[key]" :label="'exclude domains'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'freeTwitterApiHandles'" sm4 subheading offset-sm3 class="text-sm-left"> 
                free twitter api handles: 
              </v-flex>
              <v-flex v-if="key === 'freeTwitterApiHandles'" sm8>
                <v-text-field v-model="config[key]" :label="'free twitter api handles (csv)'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'freeTwitterApiHashtags'" sm4 subheading offset-sm3 class="text-sm-left"> 
                free twitter api hashtags: 
              </v-flex>
              <v-flex v-if="key === 'freeTwitterApiHashtags'" sm8>
                <v-text-field v-model="config[key]" :label="'free twitter api hashtags (csv)'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'freeTwitterApiKeywords'" sm4 subheading offset-sm3 class="text-sm-left"> 
                free twitter api keywords: 
              </v-flex>
              <v-flex v-if="key === 'freeTwitterApiKeywords'" sm8>
                <v-text-field v-model="config[key]" :label="'free twitter api keywords (csv)'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'freeTwitterApiConsumerKey'" sm4 subheading offset-sm3 class="text-sm-left"> 
                free twitter api key: 
              </v-flex>
              <v-flex v-if="key === 'freeTwitterApiConsumerKey'" sm8>
                <v-text-field v-model="config[key]" :label="'free twitter api key'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'freeTwitterApiConsumerSecret'" sm4 subheading offset-sm3 class="text-sm-left"> 
                free twitter api secret: 
              </v-flex>
              <v-flex v-if="key === 'freeTwitterApiConsumerSecret'" sm8>
                <v-text-field v-model="config[key]" :label="'free twitter api secret'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'freeTwitterApiAccessToken'" sm4 subheading offset-sm3 class="text-sm-left"> 
                free twitter api token: 
              </v-flex>
              <v-flex v-if="key === 'freeTwitterApiAccessToken'" sm8>
                <v-text-field v-model="config[key]" :label="'free twitter api token'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'freeTwitterApiAccessTokenSecret'" sm4 subheading offset-sm3 class="text-sm-left"> 
                free twitter api access token secret: 
              </v-flex>
              <v-flex v-if="key === 'freeTwitterApiAccessTokenSecret'" sm8>
                <v-text-field v-model="config[key]" :label="'free twitter api access token secret'"></v-text-field>
              </v-flex>

              <v-flex v-if="key === 'databaseName'" sm4 subheading offset-sm3 class="text-sm-left"> 
                database name: 
              </v-flex>
              <v-flex v-if="key === 'databaseName' && createDatabase === true && !config.databaseProvider" sm8>
                <v-text-field v-model="config[key]" :label="'database name'" required @input="$v.configDatabaseName.$touch()" :error-messages="configDatabaseNameErrorMsgs"> 
                  database name: 
                </v-text-field>
              </v-flex>
              <v-flex v-if="key === 'databaseName' && createDatabase === false && !config.databaseProvider" sm8>
                <v-text-field v-model="config[key]" :label="'database name'"></v-text-field>
              </v-flex>
              <v-flex v-if="key === 'databaseName' && createDatabase === true && config.databaseProvider" sm8>
                <v-text-field v-model="config[key]" :label="'database name'" required @blur="$v.configDatabaseName.$touch()" :error-messages="configDatabaseNameErrorMsgs" readonly> 
                  database name: 
                </v-text-field>
              </v-flex>
              <v-flex v-if="key === 'databaseName' && createDatabase === false && config.databaseProvider" sm8>
                <v-text-field v-model="config[key]" :label="'database name'" readonly></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row v-for="(item, index) in config.rules" class="full-width" :key=index>
              <v-flex sm4 subheading offset-sm3 class="text-sm-left" v-if="index === 0"> 
                gnip rules:
              </v-flex>
              <v-flex sm4 subheading offset-sm3 class="text-sm-left" v-if="index !== 0"> 

              </v-flex>
              <v-flex sm8 v-if="index === 0">
                <v-text-field v-model="config.rules[index]" :label="'GNIP Rule ' + (index + 1)" append-icon="add" @click:append="config.rules.push(''); rulesErrors.push(false); rulesErrorMsgs.push('');" @blur="validateGNIPRule(config.rules[index], index)" validate-on-blur :error="rulesErrors[index]" :error-messages="rulesErrorMsgs[index]" />
              </v-flex>
              <v-flex sm8 v-if="index !== 0">
                <v-text-field v-model="config.rules[index]" :label="'GNIP Rule ' + (index + 1)" append-icon="remove" @click:append="config.rules.splice(index, 1); rulesErrors.splice(index, 1); rulesErrorMsgs.splice(index, 1);" @blur="validateGNIPRule(config.rules[index], index)" validate-on-blur :error="rulesErrors[index]" :error-messages="rulesErrorMsgs[index]" />
              </v-flex>
            </v-layout>

            <v-dialog v-model="newElementDialog" max-width="500px">
              <v-card>
                <v-card-text>
                  <v-text-field v-model="newItem" label="Field Name"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" flat @click.stop="addConfigElement">Add</v-btn>
                  <v-btn color="primary" flat @click.stop="newElementDialog=false">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-flex sm3 subheading>Users: </v-flex>
            <v-flex sm9>
              <v-autocomplete :items="allUsers" v-model="userIds" label="Select" item-text="firstName" item-value="id" multiple chips :menu-props="{maxHeight:'auto'}">
                <template slot="users" slot-scope="data">
                  <v-chip :selected="data.users" :key="JSON.stringify(data.item)" close class="chip--select-multi primary" @input="data.parent.selectItem([data.users.item])">
                    {{ data.item.firstName }} {{ data.item.lastName }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.firstName + ' ' + data.item.lastName"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.email"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            
            <v-flex sm3 subheading v-if="!config.databaseProvider">Create Database: </v-flex>
            <v-flex sm9 v-if="!config.databaseProvider">
              <v-checkbox v-model="createDatabase" hide-details color="primary"></v-checkbox>
            </v-flex>
            
            <v-flex sm3 subheading>Sync GNIP Rules on Save: </v-flex>
            <v-flex sm9>
              <v-checkbox v-model="syncGnipRules" hide-details color="primary"></v-checkbox>
            </v-flex>
            
            <v-flex sm3 subheading>Use Free Twitter API: </v-flex>
            <v-flex sm9>
              <v-checkbox v-model="config.freeTwitterApiUse" hide-details color="primary"></v-checkbox>
            </v-flex>
            
            <v-flex sm3 subheading>Use Free Twitter API (Strict Mode): </v-flex>
            <v-flex sm9>
              <v-checkbox v-model="config.freeTwitterApiUseStrict" hide-details color="primary"></v-checkbox>
            </v-flex>

            <v-flex sm3 subheading>Use Free Twitter API (Restricted Mode): </v-flex>
            <v-flex sm9>
              <v-checkbox v-model="config.freeTwitterApiUseRestricted" hide-details color="primary"></v-checkbox>
            </v-flex>
          </v-layout>
          
          <v-btn @click="submit">Submit</v-btn>
          <v-btn @click="cancel">Cancel</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style scoped>
.full-width{width: 100%}
</style>
<script>
import Vue from 'vue'
import vh, { name, description, configDatabaseName, configNewsapi } from '@/helpers/validators'
import { getUDT } from '@/helpers/formatters'
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: ['id'],
  data () {
    return {
      uuid: null,
      name: null,
      description: null,
      status: null,
      archiveDate: null,
      config: {
        version: '0',
        rules: [''],
        newsapi: null,
        bingnewsapi: null,
        bingwebapi: null,
        freeTwitterApiUse: false,
        freeTwitterApiUseStrict: false,
        freeTwitterApiUseRestricted: false,
        freeTwitterApiHandles: null,
        freeTwitterApiHashtags: null,
        freeTwitterApiKeywords: null,
        freeTwitterApiHandlesRestricted: null,
        freeTwitterApiKeywordsRestricted: null,
        excludeTerms: null,
        excludeTwitterUsers: null,
        excludeDomains: null,
        freeTwitterApiConsumerKey: null,
        freeTwitterApiConsumerSecret: null,
        freeTwitterApiAccessToken: null,
        freeTwitterApiAccessTokenSecret: null,
        databaseName: null
      },
      dateAdded: null,
      dateModified: null,
      users: [],
      userIds: [],
      createDatabase: false,
      syncGnipRules: false,
      statusArray: ['Active', 'Pending Activation', 'Archived', 'Draft', 'Disabled'],
      rulesErrors: [false],
      rulesErrorMsgs: [''],
      newElementDialog: false,
      newItem: ''
    }
  },
  validations: {
    name: vh.vrules(name),
    description: vh.vrules(description),
    configDatabaseName: vh.vrules(configDatabaseName),
    configNewsapi: vh.vrules(configNewsapi)
  },
  computed: {
    ...mapGetters({
      getProjectById: 'getProjectById',
      getUserById: 'getUserById',
      allUsers: 'getUsers',
      gnipRules: 'getGNIPRules'
    }),
    configNewsapi () {
      return this.config.newsapi
    },
    configDatabaseName () {
      return this.config.databaseName
    },
    nameErrorMsgs () {
      if (this.$v.name.$dirty) {
        return vh.vmsg(this.$v.name, name)
      } else {
        return []
      }
    },
    descriptionErrorMsgs () {
      if (this.$v.description.$dirty) {
        return vh.vmsg(this.$v.description, description)
      } else {
        return []
      }
    },
    configDatabaseNameErrorMsgs () {
      if (this.$v.configDatabaseName.$dirty) {
        return vh.vmsg(this.$v.configDatabaseName, configDatabaseName)
      } else {
        return []
      }
    },
    configNewsapiErrorMsgs () {
      if (this.$v.configNewsapi.$dirty) {
        return vh.vmsg(this.$v.configNewsapi, configNewsapi)
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('loading', ['showLoading', 'hideLoading']),
    getGNIPRules () {
      axios.all([this.$store.dispatch('getGNIPRules')]).then(axios.spread((gnipRulesResponse) => {
        if (gnipRulesResponse.data.status === 'SUCCESS') {
          this.$store.commit('setGNIPRules', gnipRulesResponse.data.payload)
        } else {
          this.notify({message: 'Something went wrong while fetching GNIP rules.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    deleteGNIPRuleSync: async function (payload) {
      try {
        return await this.$store.dispatch('deleteGNIPRule', payload)
      } catch (err) {
        console.log(err)
        return false
      }
    },
    updateGNIPRule (rule) {
      axios.all([this.$store.dispatch('updateGNIPRule', rule)]).then(axios.spread((gnipRulesResponse) => {
        if (gnipRulesResponse.data.status === 'SUCCESS') {
          this.$store.commit('updateGNIPRule', gnipRulesResponse.data.payload)
        } else {
          this.notify({message: 'Something went wrong while updating GNIP rule.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    updateGNIPRuleSync: async function (rule) {
      try {
        return await this.$store.dispatch('updateGNIPRule', rule)
      } catch (err) {
        console.log(err)
        return false
      }
    },
    addGNIPRule (rule) {
      axios.all([this.$store.dispatch('addGNIPRule', rule)]).then(axios.spread((gnipRulesResponse) => {
        if (gnipRulesResponse.data.status === 'SUCCESS') {
          this.$store.commit('addGNIPRule', gnipRulesResponse.data.payload)
        } else {
          this.notify({message: 'Something went wrong while adding GNIP rule.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    addGNIPRuleSync: async function (rule) {
      try {
        return await this.$store.dispatch('addGNIPRule', rule)
      } catch (err) {
        console.log(err)
        return false
      }
    },
    validateGNIPRule (rule, index) {
      if (rule === '') {
        this.$set(this.rulesErrors, index, false)
        this.$set(this.rulesErrorMsgs, index, '')
        return true
      }

      axios.all([this.$store.dispatch('validateGNIPRule', rule)]).then(axios.spread(r => {
        if (r.data.status === 'SUCCESS' && Boolean(r.data.payload) === true) {
          this.$set(this.rulesErrors, index, false)
          this.$set(this.rulesErrorMsgs, index, '')
        } else {
          this.$set(this.rulesErrors, index, true)
          this.$set(this.rulesErrorMsgs, index, 'GNIP rule is not valid.')
        }
      })).catch((err) => {
        console.log(err)
        this.$set(this.rulesErrors, index, true)
        this.$set(this.rulesErrorMsgs, index, 'GNIP rule is not valid.')
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
      })
    },
    validateGNIPRuleSync: async function (rule, index) {
      if (rule === '') {
        this.$set(this.rulesErrors, index, false)
        this.$set(this.rulesErrorMsgs, index, '')
        return true
      }

      try {
        const response = await this.$store.dispatch('validateGNIPRule', rule)
        const data = await response.data
        if (data.status !== 'SUCCESS' || !data.payload) {
          this.$set(this.rulesErrors, index, true)
          this.$set(this.rulesErrorMsgs, index, 'GNIP rule is not valid.')
          return false
        }
        if (Boolean(await data.payload) === true) {
          this.$set(this.rulesErrors, index, false)
          this.$set(this.rulesErrorMsgs, index, '')
          return true
        } else {
          this.$set(this.rulesErrors, index, true)
          this.$set(this.rulesErrorMsgs, index, 'GNIP rule is not valid.')
          return false
        }
      } catch (err) {
        console.log(err)
        this.$set(this.rulesErrors, index, true)
        this.$set(this.rulesErrorMsgs, index, 'GNIP rule is not valid.')
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        return false
      }
    },
    createProjectSync: async function (payload) {
      try {
        return await this.$store.dispatch('addProject', payload)
      } catch (err) {
        console.log(err)
        return false
      }
    },
    updateProjectSync: async function (payload) {
      try {
        return await this.$store.dispatch('updateProject', payload)
      } catch (err) {
        console.log(err)
        return false
      }
    },
    createDatabaseSync: async function (payload) {
      try {
        return await this.$store.dispatch('createDB', payload)
      } catch (err) {
        console.log(err)
        return false
      }
    },
    getData () {
      axios.all([this.$store.dispatch('getUsers')]).then(axios.spread((usersResponse) => {
        if (usersResponse.data.status === 'SUCCESS') {
          this.$store.commit('setUsers', usersResponse.data.payload)
        } else {
          this.notify({message: 'Something went wrong while fetching users.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    addConfigElement () {
      Vue.set(this.config, this.newItem, '')
      this.newElementDialog = false
    },
    async createProject () {
      this.users = []
      for (var u = 0; u < this.userIds.length; u++) {
        this.users.push(this.getUserById(this.userIds[u]))
      }

      var localConfig = Vue.util.extend({}, this.config)
      localConfig.rules = localConfig.rules.slice()
      localConfig.rules = localConfig.rules.filter(e => e)

      var project = {
        name: this.name,
        description: this.description,
        status: this.status,
        config: localConfig,
        users: this.users,
        archiveDate: this.status === 'Archived' ? getUDT() : null
      }

      this.showLoading('Setting everything up. This might take a couple of minutes.')

      var projectResponse = await this.createProjectSync(project)
      if (!projectResponse.data || projectResponse.data.status !== 'SUCCESS') {
        this.hideLoading()
        this.notify({message: 'Something went wrong while creating project.', show: true})
        return
      }

      if (this.createDatabase) {
        var databaseResponse = await this.createDatabaseSync({config: localConfig, projectId: Number(projectResponse.data.payload.id)})
        if (!databaseResponse.data || databaseResponse.data.status !== 'SUCCESS') {
          this.hideLoading()
          this.notify({message: 'Something went wrong while creating database. Make sure it does not already exist.', show: true})
          return
        }
      }

      if (this.syncGnipRules) {
        var gnipResponse = await this.deleteGNIPRuleSync({tag: projectResponse.data.payload.uuid})
        if (!gnipResponse.data || gnipResponse.data.status !== 'SUCCESS') {
          this.hideLoading()
          this.notify({message: 'Something went wrong while synchronizing GNIP rules.', show: true})
          return
        }

        for (var i = 0; i < localConfig.rules.length; i++) {
          var rule = {tag: projectResponse.data.payload.uuid, value: localConfig.rules[i]}
          var ruleResponse = await this.addGNIPRuleSync(rule)
          if (!ruleResponse.data || ruleResponse.data.status !== 'SUCCESS') {
            this.hideLoading()
            this.notify({message: 'Something went wrong while synchronizing GNIP rules.', show: true})
            return
          }
        }
      }

      setTimeout(function () {
        this.hideLoading()
        this.notify({message: 'Project successfully created.', show: true})
        this.$router.push('./')
      }.bind(this), 250)
    },
    async updateProject () {
      this.users = []
      for (var u = 0; u < this.userIds.length; u++) {
        this.users.push(this.getUserById(this.userIds[u]))
      }

      var localConfig = Vue.util.extend({}, this.config)
      localConfig.rules = localConfig.rules.slice()
      localConfig.rules = localConfig.rules.filter(e => e)

      var project = {
        id: Number(this.id),
        name: this.name,
        description: this.description,
        status: this.status,
        config: localConfig,
        users: this.users,
        archiveDate: this.status === 'Archived' ? getUDT() : null
      }

      var projectResponse = await this.updateProjectSync(project)
      if (!projectResponse.data || projectResponse.data.status !== 'SUCCESS') {
        this.hideLoading()
        this.notify({message: 'Something went wrong while updating project.', show: true})
        return
      }

      if (this.createDatabase) {
        var databaseResponse = await this.createDatabaseSync({config: localConfig, projectId: Number(projectResponse.data.payload.id)})
        if (!databaseResponse.data || databaseResponse.data.status !== 'SUCCESS') {
          this.hideLoading()
          this.notify({message: 'Something went wrong while creating database. Make sure it does not already exist.', show: true})
          return
        }
      }

      if (this.syncGnipRules) {
        var gnipResponse = await this.deleteGNIPRuleSync({tag: projectResponse.data.payload.uuid})
        if (!gnipResponse.data || gnipResponse.data.status !== 'SUCCESS') {
          this.hideLoading()
          this.notify({message: 'Something went wrong while synchronizing GNIP rules.', show: true})
          return
        }

        for (var i = 0; i < localConfig.rules.length; i++) {
          var rule = {tag: projectResponse.data.payload.uuid, value: localConfig.rules[i]}
          var ruleResponse = await this.addGNIPRuleSync(rule)
          if (!ruleResponse.data || ruleResponse.data.status !== 'SUCCESS') {
            this.hideLoading()
            this.notify({message: 'Something went wrong while synchronizing GNIP rules.', show: true})
            return
          }
        }
      }

      setTimeout(function () {
        this.hideLoading()
        this.notify({message: 'Project successfully updated.', show: true})
        this.$router.push('./')
      }.bind(this), 250)
    },
    async submit () {
      this.showLoading('Setting everything up. This might take a couple of minutes.')
      this.$v.name.$touch()
      this.$v.description.$touch()
      this.$v.configDatabaseName.$touch()

      if (this.config && this.config.rules) {
        for (var i = 0; i < this.config.rules.length; i++) {
          this.rulesErrors[i] = true
          await this.validateGNIPRuleSync(this.config.rules[i], i)
        }
      }

      for (var j = 0; j < this.config.rules.length; j++) {
        if (this.rulesErrors[j] === true) {
          this.hideLoading()
          return
        }
      }

      if (this.$v.name.$invalid || this.$v.description.$invalid) {
        this.hideLoading()
        return
      }

      if (this.createDatabase === true) {
        if (this.$v.configDatabaseName.$invalid) {
          this.hideLoading()
          return
        }
      }

      if (this.syncGnipRules === true & !this.config.databaseProvider & this.createDatabase === false) {
        this.hideLoading()
        this.notify({message: 'You must create a database to sync GNIP rules.', show: true})
        return
      }

      if (!this.id) {
        setTimeout(function () { this.createProject() }.bind(this), 150)
      } else {
        setTimeout(function () { this.updateProject() }.bind(this), 150)
      }
    },
    cancel () {
      this.$router.push('./')
    }
  },
  mounted: async function () {
    this.getData()
    this.getGNIPRules()

    if (this.config && this.config.rules) {
      for (var i = 0; i < this.config.rules.length; i++) {
        await this.validateGNIPRuleSync(this.config.rules[i], i)
      }
    }
  },
  created: function () {
    if (!this.id) {
      return
    }

    const project = this.getProjectById(this.id)

    if (!project) {
      this.$router.push('./')
      return
    }

    this.uuid = project.uuid
    this.name = project.name
    this.description = project.description
    this.status = project.status
    this.config = Vue.util.extend({}, project.config)
    if (this.config.rules) {
      this.config.rules = project.config.rules.slice()
      if (this.config.rules.length === 0) {
        this.config.rules = ['']
      }
      this.rulesErrors = []
      this.rulesErrorMsgs = []
      for (var i = 0; i < this.config.rules.length; i++) {
        this.rulesErrors.push(false)
        this.rulesErrorMsgs.push('')
      }
    }
    if (!this.config.version) {
      this.config = Vue.util.extend({version: '0'}, this.config)
    }
    if (!this.config.rules || this.config.rules.length === 0) {
      this.config = Vue.util.extend({rules: ['']}, this.config)
    }
    if (!this.config.newsapi) {
      this.config = Vue.util.extend({newsapi: null}, this.config)
    }
    if (!this.config.bingnewsapi) {
      this.config = Vue.util.extend({bingnewsapi: null}, this.config)
    }
    if (!this.config.bingwebapi) {
      this.config = Vue.util.extend({bingwebapi: null}, this.config)
    }
    if (!this.config.databaseName) {
      this.config = Vue.util.extend({databaseName: null}, this.config)
    }
    if (!this.config.freeTwitterApiHandles) {
      this.config = Vue.util.extend({freeTwitterApiHandles: null}, this.config)
    }
    if (!this.config.freeTwitterApiHashtags) {
      this.config = Vue.util.extend({freeTwitterApiHashtags: null}, this.config)
    }
    if (!this.config.freeTwitterApiKeywords) {
      this.config = Vue.util.extend({freeTwitterApiKeywords: null}, this.config)
    }
    if (!this.config.freeTwitterApiHandlesRestricted) {
      this.config = Vue.util.extend({freeTwitterApiHandlesRestricted: null}, this.config)
    }
    if (!this.config.freeTwitterApiKeywordsRestricted) {
      this.config = Vue.util.extend({freeTwitterApiKeywordsRestricted: null}, this.config)
    }
    if (!this.config.excludeTerms) {
      this.config = Vue.util.extend({excludeTerms: null}, this.config)
    }
    if (!this.config.excludeTwitterUsers) {
      this.config = Vue.util.extend({excludeTwitterUsers: null}, this.config)
    }
    if (!this.config.excludeDomains) {
      this.config = Vue.util.extend({excludeDomains: null}, this.config)
    }
    if (!this.config.freeTwitterApiConsumerKey) {
      this.config = Vue.util.extend({freeTwitterApiConsumerKey: null}, this.config)
    }
    if (!this.config.freeTwitterApiConsumerSecret) {
      this.config = Vue.util.extend({freeTwitterApiConsumerSecret: null}, this.config)
    }
    if (!this.config.freeTwitterApiAccessToken) {
      this.config = Vue.util.extend({freeTwitterApiAccessToken: null}, this.config)
    }
    if (!this.config.freeTwitterApiAccessTokenSecret) {
      this.config = Vue.util.extend({freeTwitterApiAccessTokenSecret: null}, this.config)
    }

    this.archiveDate = project.archiveDate
    this.dateAdded = project.dateAdded
    this.dateModified = project.dateModified
    this.users = project.users
    this.userIds = []
    for (var j = 0; j < this.users.length; j++) {
      this.userIds.push(Number(this.users[j].id))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects/Project.vue